var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { deburr, uniqBy, isEmpty, escapeRegExp } from 'lodash';
import { json } from 'overmind';
import Input from 'components/Input.vue';
import { mixpanelTracking } from '@/services/mixpanel';
import { connect } from '@/overmind';
let DecisionMakersPanel = class DecisionMakersPanel extends Vue {
    constructor() {
        super(...arguments);
        this.selectedDecisorPositions = [];
        this.filterOptions = this.filters.map(f => f.filterOptions);
        this.filteredFilters = json(this.filters);
        this.inputText = json(this.nameSocio);
        this.currentFilterIndex = 0;
        this.searchTerm = '';
        this.orCheckBox = true;
        this.andCheckBox = false;
    }
    mounted() {
        this.selectedDecisorPositions = json(
        //@ts-ignore
        this.stateFilters.selectedDecisorPositions);
        this.loadCheckBoxValueFromState(this.selectedFilteredType);
        this.handlePreVisualization();
        this.searchTerm = this.fullTextTerm;
        if (this.fullTextTerm !== '') {
            this.filters.forEach(f => {
                this.onSearchFilters(f, this.fullTextTerm);
                this.currentFilterIndex += 1;
            });
            this.currentFilterIndex -= 1;
        }
    }
    inputCheckBox(value) {
        this.loadCheckBoxValueFromState(value);
        this.setSelectFilteredType(value);
    }
    loadCheckBoxValueFromState(value) {
        if (value == 'OU' || value == '') {
            this.orCheckBox = true;
            this.andCheckBox = false;
        }
        if (value == 'E') {
            this.orCheckBox = false;
            this.andCheckBox = true;
        }
    }
    setDecisorPositionFilter({ value }, type) {
        //@ts-ignore
        this.filtersActions.setSelectedDecisorPosition({ value, type });
        //@ts-ignore
        this.actionsSearch.searches.buildPotentialResults();
    }
    get department() {
        return json(this.filters)
            .find(f => f.queryField == 'decision_makers_lkd_m5.department')
            .filterOptions.map(f => {
            if (f && f.isSelected)
                return f.label;
        })
            .filter(f => f && f !== '');
    }
    get level() {
        return json(this.filters)
            .find(f => f.queryField == 'decision_makers_lkd_m5.level')
            .filterOptions.map(f => {
            if (f && f.isSelected)
                return f.label;
        })
            .filter(f => f && f !== '');
    }
    handlePreVisualization() {
        return this.department.length > 0 || this.level.length > 0;
    }
    onFilters(curr, old) {
        if (curr) {
            this.filteredFilters = json(curr);
            this.filterOptions = curr.map(f => f.filterOptions);
        }
    }
    handleTitle(title) {
        const newTitle = title != 'Departamento do decisor'
            ? title
            : 'Departamento, nível e meios de contato do decisor';
        return newTitle;
    }
    handleFilteredFilters() {
        return this.filteredFilters.filter(f => !['decision_makers_lkd_m5.level', '_multiple_decisors_with_'].includes(f.queryField));
    }
    handleLevelDecisors() {
        return this.filters.filter(f => f.queryField == 'decision_makers_lkd_m5.level');
    }
    get handleDecisorWithFilter() {
        return this.filters.find(f => f.queryField == '_multiple_decisors_with_');
    }
    onFullTextSearchChange(curr, old) {
        this.searchTerm = this.fullTextTerm;
        this.filters.forEach(f => {
            this.onSearchFilters(f, this.fullTextTerm);
            this.currentFilterIndex += 1;
        });
        this.currentFilterIndex -= 1;
    }
    async onFilterIndexChange(curr, old) {
        this.filterOptions[curr] =
            this.filters[this.currentFilterIndex].filterOptions;
    }
    setInputFilter(event) {
        return event;
    }
    selectedCount(filter) {
        if (filter.queryType === 'multiSelect') {
            if (this.isDepartmentFilter(filter)) {
                const departmentCount = filter.filterOptions.filter(option => option.isSelected).length;
                const levelCount = this.filters
                    .find(f => f.queryField == 'decision_makers_lkd_m5.level')
                    .filterOptions.filter(f => f.isSelected).length;
                const contacts = this.filters
                    .find(f => f.title == 'Decisores com')
                    .filterOptions.filter(opt => opt.isSelected).length;
                return departmentCount + levelCount + contacts;
            }
            return filter
                ? filter.filterOptions.filter(option => option.isSelected).length
                : 0;
        }
        if (filter.queryType === 'inputText') {
            return !isEmpty(this.inputText) ? 1 : 0;
        }
        if (filter.queryType === 'multiText') {
            return this.selectedDecisorPositions.length;
        }
    }
    onSearchFilters(filter, event) {
        const filterIndex = this.filteredFilters.findIndex(f => f.queryField === filter.queryField);
        if (filterIndex === -1)
            return;
        if (event == null || event.trim() === '') {
            this.searchTerm = '';
            this.filteredFilters[filterIndex].filterOptions = json(this.filterOptions[filterIndex]);
            return;
        }
        this.searchTerm = event;
        let filterOptions = json(this.filterOptions[filterIndex].filter(o => {
            const deburedTerm = escapeRegExp(deburr(event.trim()));
            if (o.tags) {
                const debured = deburr(Array.isArray(o.tags) ? o.tags.join(', ') : [o.tags].join(', '));
                const deburedMatch = debured.match(new RegExp(deburedTerm, 'gi'));
                if (deburedMatch)
                    return deburedMatch;
            }
            const deburedLabel = o.label ? deburr(o.label) : undefined;
            return o.label && deburedLabel
                ? deburedLabel.match(new RegExp(deburedTerm, 'i'))
                : false;
        }));
        filterOptions = uniqBy(filterOptions, 'value');
        this.filteredFilters[filterIndex].filterOptions = json(filterOptions);
    }
    onHideFilter(filter) {
        if (this.fullTextTerm === '') {
            const filterIndex = this.filteredFilters.findIndex(f => f.queryField === filter.queryField);
            if (filterIndex !== -1) {
                this.filteredFilters[filterIndex].filterOptions = json(this.filters[filterIndex].filterOptions);
            }
        }
    }
    onShowFilter(filter, filterTitle) {
        const trackingMessage = filterTitle == 'Departamento do decisor'
            ? 'Filtros avançados: expandiu filtro de departamento e nível do decisor'
            : 'Filtros avançados: Expandiu o grupo de filtros: ' + filterTitle;
        mixpanelTracking(trackingMessage);
        this.currentFilterIndex = this.filteredFilters.findIndex(f => f.queryField === filter.queryField);
        this.searchTerm = '';
    }
    setCheckbox(filterGroupId, filterId, filterIndex, filterOptionIndex, value, itemId, filterName) {
        this.setCheckboxTracking(filterName, value, itemId);
        const option = this.filteredFilters[filterIndex].filterOptions.find(o => o.value === itemId);
        if (option) {
            this.filteredFilters[filterIndex].filterOptions[filterOptionIndex].isSelected = value;
        }
        this.$emit('setCheckbox', filterGroupId, filterId, filterIndex, filterOptionIndex, value, itemId);
    }
    getFilterIndex(queryField) {
        return this.filteredFilters.findIndex(f => f.queryField === queryField);
    }
    formatDecisionMakerLabel(label) {
        switch (label) {
            case 'Alto':
                return 'Alto: proprietários, diretores, sócios e relacionados';
            case 'Médio':
                return 'Médio: gerentes, coordenadores, líderes e relacionados';
            case 'Baixo':
                return 'Baixo: analistas, assistentes, estagiários e relacionados';
            case 'Não classificado':
                return 'Não classificado';
            default:
                return label;
        }
    }
    setCheckboxTracking(filterName, value, itemId) {
        const filterMessage = filterName == 'departamento'
            ? 'no departamento do decisor'
            : 'no nível do decisor';
        const markOrDismark = value ? 'marcou' : 'desmarcou';
        if (itemId) {
            mixpanelTracking(`Filtros avançados: ${markOrDismark} “${itemId}” ${filterMessage} `);
        }
    }
    setSelectFilteredType(value) {
        mixpanelTracking(`Filtros avançados: marcou “${value == '' ? 'OU' : value}” na lógica dos filtros de departamento e nível do decisor`);
        return value;
    }
    beforeDestroy() {
        this.filteredFilters[this.currentFilterIndex].filterOptions = json(this.filterOptions[this.currentFilterIndex]);
    }
    // essa regra existe pois somente os filtros de departamento, nível e "decisor com" possuem lógica de
    // E/OU e devem ficar juntos dentro do item do componente de sanfona
    isDepartmentFilter(filter) {
        return filter.queryField.match('department');
    }
    get selectedContactsFilter() {
        const filter = this.filters.find(f => f.title == 'Decisores com') || {};
        const options = filter.filterOptions || [];
        return options.filter(opt => opt.isSelected).map(opt => opt.label);
    }
};
__decorate([
    Prop({ default: () => [] })
], DecisionMakersPanel.prototype, "filters", void 0);
__decorate([
    Prop({ default: '' })
], DecisionMakersPanel.prototype, "radioButtonCnae", void 0);
__decorate([
    Prop({ default: 1 })
], DecisionMakersPanel.prototype, "filterGroupId", void 0);
__decorate([
    Prop({ default: '' })
], DecisionMakersPanel.prototype, "fullTextTerm", void 0);
__decorate([
    Prop({ default: '' })
], DecisionMakersPanel.prototype, "nameSocio", void 0);
__decorate([
    Prop({ default: 'OU' })
], DecisionMakersPanel.prototype, "selectedFilteredType", void 0);
__decorate([
    Watch('filters', { deep: true })
], DecisionMakersPanel.prototype, "onFilters", null);
__decorate([
    Watch('fullTextTerm')
], DecisionMakersPanel.prototype, "onFullTextSearchChange", null);
__decorate([
    Watch('currentFilterIndex')
], DecisionMakersPanel.prototype, "onFilterIndexChange", null);
__decorate([
    Emit('setInputFilter')
], DecisionMakersPanel.prototype, "setInputFilter", null);
__decorate([
    Emit('setSelectFilteredType')
], DecisionMakersPanel.prototype, "setSelectFilteredType", null);
DecisionMakersPanel = __decorate([
    Component(connect(({ actions, state: { filters: stateFilters } }) => ({
        filtersActions: actions.filters,
        actionsSearch: actions.search,
        stateFilters: stateFilters,
    }), {
        name: 'DecisionMakersPanel',
        components: { Input },
    }))
], DecisionMakersPanel);
export default DecisionMakersPanel;
